import { render, staticRenderFns } from "./shopCarOther.vue?vue&type=template&id=edca17f6&scoped=true&"
import script from "./shopCarOther.vue?vue&type=script&lang=js&"
export * from "./shopCarOther.vue?vue&type=script&lang=js&"
import style0 from "./shopCarOther.vue?vue&type=style&index=0&id=edca17f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edca17f6",
  null
  
)

export default component.exports